import React from 'react';
import Acompanian from '../componentes/acompanian';
import Organizan from '../componentes/organizan';
import Proyectos from './proyectos';

export default function Home() { 
	
	document.title = "Hackaton 3d :: Home";

	return (
		<React.Fragment>
			<p className="text-center mb-5">Sumate al desafío y creá herramientas educativas en 3D para personas con discapacidad visual.</p>

			<Proyectos />

			<Organizan />
			<Acompanian />
		</React.Fragment>    
	);
}